import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Sidebar = ({ collapsed, onToggle, permissions = []  }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('');

  const haspermission = (permName) => {
    return permissions.some(p => p.name === permName);
  };

  // console.log(userRole)

  // const navigationItems = [
  //   {
  //     section: 'overview',
  //     label: 'Overview',
  //     items: [
  //       {
  //         label: 'Dashboard',
  //         path: '/dashboard',
  //         icon: 'LayoutDashboard',
  //         roles: ['admin', 'staff', 'client'],
  //         tooltip: 'Financial overview and insights'
  //       }
  //     ]
  //   },
  //   // {
  //   //   section: 'transactions',
  //   //   label: 'Transactions',
  //   //   items: [
  //   //     {
  //   //       label: 'Transaction Management',
  //   //       path: '/transactions-management',
  //   //       icon: 'Receipt',
  //   //       roles: ['partner', 'staff', 'freelancer'],
  //   //       tooltip: 'Manage financial transactions'
  //   //     },
  //   //     {
  //   //       label: 'Bank Reconciliation',
  //   //       path: '/bank-reconciliation',
  //   //       icon: 'Building2',
  //   //       roles: ['partner', 'staff', 'freelancer'],
  //   //       tooltip: 'Reconcile bank statements'
  //   //     }
  //   //   ]
  //   // },
  //   // {
  //   //   section: 'reports',
  //   //   label: 'Reports & Compliance',
  //   //   items: [
  //   //     {
  //   //       label: 'Financial Reports',
  //   //       path: '/financial-reports',
  //   //       icon: 'FileText',
  //   //       roles: ['partner', 'staff', 'freelancer'],
  //   //       tooltip: 'Generate financial statements'
  //   //     },
  //   //     {
  //   //       label: 'Tax Compliance Center',
  //   //       path: '/tax-compliance-center',
  //   //       icon: 'Calculator',
  //   //       roles: ['partner', 'staff'],
  //   //       tooltip: 'Tax filing and compliance'
  //   //     }
  //   //   ]
  //   // },
  //   {
  //     section: 'administration',
  //     label: 'Administration',
  //     items: [
  //       {
  //         label: 'User Management',
  //         path: '/user-management',
  //         icon: 'Users',
  //         roles: ['admin','staff'],
  //         tooltip: 'Manage system users'
  //       },
  //       {
  //         label: 'Product Management',
  //         path: '/product-management',
  //         icon: 'Package',
  //         roles: ['partner', 'admin', 'staff', 'client'],
  //         tooltip: 'Manage product catalog'
  //       }//,
  //       // {
  //       //   label: 'QR Code Management',
  //       //   path: '/qr-code-management',
  //       //   icon: 'QrCode',
  //       //   roles: ['partner', 'staff'],
  //       //   tooltip: 'Manage QR codes'
  //       //  },
  //       // {
  //       //   label: 'Client Portal',
  //       //   path: '/client-portal',
  //       //   icon: 'Globe',
  //       //   roles: ['partner', 'staff', 'client'],
  //       //   tooltip: 'Client access and communication'
  //       // }
  //     ]
  //   }
  // ];

  const navigationItems = [
    {
      section: 'overview',
      label: 'Overview',
      items: [
        {
          label: 'Dashboard',
          path: '/dashboard',
          icon: 'LayoutDashboard',
          permissions: [], // 👈 must match your permission names from backend
          alwaysVisible: true,
          tooltip: 'Financial overview and insights'
        }
      ]
    },
    {
      section: 'administration',
      label: 'Administration',
      items: [
        {
          label: 'User Management',
          path: '/user-management',
          icon: 'Users',
          permissions: ['User Management'],
          tooltip: 'Manage system users'
        },
        {
          label: 'Product Management',
          path: '/product-management',
          icon: 'Package',
          permissions: ["Create Product"],
          tooltip: 'Manage product catalog'
        }
      ]
    },
    {
      section: 'batchManagement',
      label: 'Batch Management',
      items: [
        {
          label:'Qr Code Management',
          path:'/qr-code-management',
          icon:'QrCode',
          alwaysVisible:true
        }
      ]

    }
  ];
  

  // Filter navigation items based on user role - ensure stable filtering
  // const filteredNavigation = React.useMemo(() => {
  //   return navigationItems.map(section => ({
  //     ...section,
  //     items: section.items.filter(item => {
  //       // Ensure userRole is always a string and handle edge cases
  //       const normalizedUserRole = typeof userRole === 'string' ? userRole.toLowerCase() : 'staff';
  //       const itemRoles = item.roles.map(role => role.toLowerCase());
  //       return itemRoles.includes(normalizedUserRole);
  //     })
  //   })).filter(section => section.items.length > 0);
  // }, [userRole]);

  const filteredNavigation = useMemo(() => {
    return navigationItems
      .map(section => ({
        ...section,
        items: section.items.filter(item =>
          item.alwaysVisible || item.permissions.some(perm => haspermission(perm))
        )
      }))
      .filter(section => section.items.length > 0);
  }, [permissions]);

  // Set active section based on current path
  useEffect(() => {
    const currentPath = location.pathname;
    for (const section of navigationItems) {
      for (const item of section.items) {
        if (item.path === currentPath) {
          setActiveSection(section.section);
          return; // Exit early when match is found
        }
      }
    }
  }, [location.pathname]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isItemActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Mobile Overlay */}
      {!collapsed && (
        <div 
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-[49]"
          onClick={onToggle}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed top-header-height left-0 h-[calc(100vh-60px)] bg-surface border-r border-border z-50
        nav-transition lg:translate-x-0
        ${collapsed ? '-translate-x-full lg:w-sidebar-collapsed' : 'translate-x-0 w-sidebar-width'}
      `}>
        <div className="flex flex-col h-full">
          {/* Sidebar Header */}
          <div className="p-4 border-b border-border">
            <div className="flex items-center justify-between">
              {!collapsed && (
                <h2 className="font-heading font-semibold text-text-primary">Navigation</h2>
              )}
              <button
                onClick={onToggle}
                className="p-2 rounded-lg hover:bg-primary-100 nav-transition"
                aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              >
                <Icon 
                  name={collapsed ? 'ChevronRight' : 'ChevronLeft'} 
                  size={16} 
                  color="#7f8c8d" 
                />
              </button>
            </div>
          </div>

          {/* Navigation Content */}
          <nav className="flex-1 overflow-y-auto py-4">
            {filteredNavigation.map((section) => (
              <div key={section.section} className="mb-6">
                {!collapsed && (
                  <h3 className="px-4 mb-2 text-xs font-caption font-medium text-text-secondary uppercase tracking-wider">
                    {section.label}
                  </h3>
                )}
                
                <ul className="space-y-1 px-2">
                  {section.items.map((item) => (
                    <li key={item.path}>
                      <button
                        onClick={() => handleNavigation(item.path)}
                        className={`
                          w-full flex items-center px-3 py-2 rounded-lg nav-transition
                          ${isItemActive(item.path)
                            ? 'bg-primary text-white' :'text-text-primary hover:bg-primary-100'
                          }
                          ${collapsed ? 'justify-center' : 'justify-start space-x-3'}
                        `}
                        title={collapsed ? item.tooltip : ''}
                        aria-label={item.label}
                      >
                        <Icon 
                          name={item.icon} 
                          size={20} 
                          color={isItemActive(item.path) ? 'white' : '#2c3e50'} 
                        />
                        {!collapsed && (
                          <span className="font-nav text-nav">{item.label}</span>
                        )}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>

          {/* Sidebar Footer */}
          {/* <div className="p-4 border-t border-border">
            {!collapsed ? (
              <div className="bg-background rounded-lg p-3">
                <div className="flex items-center space-x-3 mb-2">
                  <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center">
                    <Icon name="Zap" size={16} color="white" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-text-primary">Quick Actions</p>
                    <p className="text-xs text-text-secondary">Keyboard shortcuts</p>
                  </div>
                </div>
                <div className="space-y-1 text-xs text-text-secondary">
                  <div className="flex justify-between">
                    <span>New Transaction</span>
                    <kbd className="px-1 py-0.5 bg-primary-100 rounded text-primary font-data">Ctrl+N</kbd>
                  </div>
                  <div className="flex justify-between">
                    <span>Search</span>
                    <kbd className="px-1 py-0.5 bg-primary-100 rounded text-primary font-data">Ctrl+K</kbd>
                  </div>
                </div>
              </div>
            ) : (
              <button
                className="w-full p-2 rounded-lg hover:bg-primary-100 nav-transition flex justify-center"
                title="Quick Actions"
                aria-label="Quick Actions"
              >
                <Icon name="Zap" size={20} color="#e67e22" />
              </button>
            )}
          </div> */}
        </div>
      </aside>
    </>
  );
};

export default Sidebar;